/* PP: small behaviours for the one-product store sections. No dependencies. */
(() => {
  const pad = (n) => String(n).padStart(2, '0');

  // Sale countdown: counts to the real end date set in the section; hides once it has passed.
  document.querySelectorAll('[data-pp-countdown]').forEach((el) => {
    const end = new Date(el.dataset.ppCountdown.replace(' ', 'T'));
    if (isNaN(end)) return el.remove();
    const d = el.querySelector('[data-pp-d]'), h = el.querySelector('[data-pp-h]'), m = el.querySelector('[data-pp-m]'), s = el.querySelector('[data-pp-s]');
    const dWrap = el.querySelector('[data-pp-dwrap]'), dSep = el.querySelector('[data-pp-dsep]');
    const tick = () => {
      const left = Math.floor((end - Date.now()) / 1000);
      if (left <= 0) return el.remove();
      const days = Math.floor(left / 86400);
      if (dWrap) { dWrap.hidden = dSep.hidden = days === 0; d.textContent = pad(days); }
      h.textContent = pad(Math.floor((left % 86400) / 3600));
      m.textContent = pad(Math.floor((left % 3600) / 60));
      s.textContent = pad(left % 60);
      setTimeout(tick, 1000);
    };
    tick();
  });

  // Ships-today cutoff: before the cutoff hour shows "Order in Xh Ym to ship today".
  document.querySelectorAll('[data-pp-cutoff]').forEach((el) => {
    const hour = parseInt(el.dataset.ppCutoff, 10);
    const text = el.querySelector('[data-pp-cutoff-text]');
    const now = new Date(), cut = new Date();
    cut.setHours(hour, 0, 0, 0);
    const day = now.getDay();
    if (day === 0 || day === 6 || now >= cut) return;
    const mins = Math.floor((cut - now) / 60000);
    text.innerHTML = `Order within <strong>${Math.floor(mins / 60)}h ${mins % 60}m</strong> to ship today`;
  });

  // Falling particles (snow / rain / stars) in dark sections.
  document.querySelectorAll('[data-pp-fx]').forEach((fx) => {
    const kind = fx.dataset.ppFx;
    if (kind === 'none' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const count = kind === 'rain' ? 40 : 34;
    for (let i = 0; i < count; i++) {
      const p = document.createElement('i');
      const size = kind === 'stars' ? 2 + Math.random() * 3 : 2 + Math.random() * 4;
      p.style.cssText = `left:${Math.random() * 100}%;width:${size}px;height:${size}px;` +
        `animation-duration:${(kind === 'rain' ? 0.8 : 6) + Math.random() * (kind === 'rain' ? 0.8 : 8)}s;` +
        `animation-delay:-${Math.random() * 10}s;--pp-drift:${(Math.random() - 0.5) * 60}px;` +
        (kind === 'stars' ? `top:${Math.random() * 100}%;` : '');
      fx.appendChild(p);
    }
  });

  // Drag-to-scroll for card sliders on desktop.
  document.querySelectorAll('[data-pp-drag], [data-pp-track]').forEach((track) => {
    let down = false, startX = 0, startLeft = 0;
    track.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') return; down = true; startX = e.clientX; startLeft = track.scrollLeft; });
    window.addEventListener('pointerup', () => { down = false; });
    track.addEventListener('pointermove', (e) => { if (down) track.scrollLeft = startLeft - (e.clientX - startX); });
  });

  // Customer photo carousel: arrows + dots.
  document.querySelectorAll('[data-pp-carousel]').forEach((car) => {
    const track = car.querySelector('[data-pp-track]');
    const cards = [...track.children];
    const dots = car.querySelector('[data-pp-dots]');
    if (!cards.length) return;
    cards.forEach(() => dots.appendChild(document.createElement('span')));
    const step = () => cards[0].getBoundingClientRect().width + 16;
    const update = () => {
      const i = Math.round(track.scrollLeft / step());
      [...dots.children].forEach((d, n) => d.classList.toggle('is-on', n === Math.min(i, cards.length - 1)));
    };
    car.querySelector('[data-pp-prev]').addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    car.querySelector('[data-pp-next]').addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
    track.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
    update();
  });

  // Promo popup: once per visitor (remembered for 7 days).
  const pop = document.querySelector('[data-pp-popup]');
  if (pop) {
    const KEY = 'pp-popup-seen';
    let seen = false;
    try { seen = Date.now() - Number(localStorage.getItem(KEY) || 0) < 7 * 864e5; } catch (e) {}
    const close = () => { pop.hidden = true; try { localStorage.setItem(KEY, Date.now()); } catch (e) {} };
    pop.querySelectorAll('[data-pp-popup-close]').forEach((b) => b.addEventListener('click', close));
    pop.addEventListener('click', (e) => { if (e.target === pop) close(); });
    if (location.search.includes('customer_posted=true') || pop.querySelector('.pp-pop__ok')) pop.hidden = false;
    else if (!seen && !window.Shopify?.designMode) setTimeout(() => { pop.hidden = false; }, (Number(pop.dataset.delay) || 12) * 1000);
  }

  // Scroll-to-top button.
  const top = document.querySelector('[data-pp-top]');
  if (top) {
    const onScroll = () => top.classList.toggle('is-on', window.scrollY > 900);
    window.addEventListener('scroll', onScroll, { passive: true });
    top.addEventListener('click', () => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  // Music button: only plays when the visitor taps it.
  const music = document.querySelector('[data-pp-music]');
  if (music) {
    const audio = music.querySelector('audio');
    music.querySelector('[data-pp-music-toggle]').addEventListener('click', () => {
      if (audio.paused) { audio.play(); music.classList.add('is-playing'); }
      else { audio.pause(); music.classList.remove('is-playing'); }
    });
  }
})();
